module.exports = __webpack_public_path__ + "img/character-4.b2ea77bd.png";